import { TRANSLATIONS } from "@/i18n";
import { DIPLOMACY_STEPS } from "@/constants/diplomate";

/**
 * DiplomacySlider — CORDIALEMENT only.
 * Native range input styled to match the neo-brutalist DA. 5 crans anchored.
 */
export const DiplomacySlider = ({ lang, value, onChange }) => {
  const t = TRANSLATIONS[lang];
  // Find the closest anchored label
  const active = DIPLOMACY_STEPS.reduce((best, s) =>
    Math.abs(s.at - value) < Math.abs(best.at - value) ? s : best,
  );

  return (
    <div className="mb-8 sm:mb-10" data-testid="diplomacy-slider">
      <div className="flex items-center gap-3 mb-3">
        <span className="dossier-tag font-bold">{t.diplomacyLabel}</span>
        <span className="flex-1 h-px bg-black/15" />
        <span
          className="font-mono text-[10px] uppercase tracking-widest text-[#4A4A4A] hidden sm:inline"
        >
          {t.diplomacyHint}
        </span>
      </div>
      <div className="bg-white border-2 border-black nb-shadow-sm p-4 sm:p-5">
        <div className="flex items-baseline justify-between mb-3">
          <span
            className="font-display font-bold text-lg sm:text-xl"
            data-testid="diplomacy-label"
          >
            {t.diplomacySteps[active.key]}
          </span>
          <span className="font-mono text-xs text-[#4A4A4A]" data-testid="diplomacy-value">
            {value}/100
          </span>
        </div>
        <input
          type="range"
          min={0}
          max={100}
          step={1}
          value={value}
          onChange={(e) => onChange(parseInt(e.target.value, 10))}
          aria-label={t.diplomacyLabel}
          data-testid="diplomacy-range"
          className="w-full accent-black cursor-pointer"
        />
        <div className="flex justify-between mt-2">
          {DIPLOMACY_STEPS.map((s) => (
            <button
              key={s.key}
              type="button"
              onClick={() => onChange(s.at)}
              className={`font-mono text-[9px] sm:text-[10px] uppercase tracking-widest px-1 py-0.5 border border-transparent hover:border-black transition-colors ${
                active.key === s.key ? "text-black font-bold" : "text-[#9A9A9A]"
              }`}
              data-testid={`diplomacy-step-${s.key}`}
            >
              {t.diplomacySteps[s.key]}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};
